import { Pipe, PipeTransform } from '@angular/core';
import {
  WorkshopJobEventType,
  workshopJobEventTypeLabelMap
} from '../../models/workshop-job-event';

@Pipe({
    name: 'workshopJobEventLabel',
    standalone: true
})
export class WorkshopJobEventLabelPipe implements PipeTransform {
  transform(value: WorkshopJobEventType): string {
    return workshopJobEventTypeLabelMap.get(value);
  }
}
